import React from 'react';
import logo from '../netgen_logo.png';

const DEMO_PAGE_URL =
  process.env.PUBLIC_URL + '/interactive_background/demo/index.html';

// "Open in new window" glyph: NetLab launches as a separate app in a new tab.
const ExternalIcon = () => (
  <svg className="intro-button-icon" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"
    fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 4h6v6" />
    <path d="M20 4l-9 9" />
    <path d="M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5" />
  </svg>
);

export default function IntroPage({ onCreate, onUpload, onNetbank, onNetlab, onLogout, user }) {
  return (
    <div className="intro-container">
      <iframe
        src={DEMO_PAGE_URL}
        title="Interactive Background"
        className="background-iframe"
      />
      <img src={logo} alt="NetGen logo" className="intro-logo intro-title" />
      <div className="intro-options animated-options">
        <button className="intro-button" onClick={onCreate}>Create New Grid</button>
        <button className="intro-button secondary" onClick={onUpload}>View Existing Grid</button>
        <button className="intro-button netbank" onClick={onNetbank}>Search NetBank</button>
        <button
          className="intro-button netlab"
          onClick={onNetlab}
          title="Opens NetLab in a new tab"
        >
          NetLab
          <ExternalIcon />
        </button>
      </div>
      <div className="intro-footer animated-options">
        <a
          href="mailto:giourgkert.partalis@ait.ac.at"
          className="intro-link"
        >
          Contact Us
        </a>
        <a
          href={process.env.PUBLIC_URL + '/docs.html'}
          className="intro-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          Documentation
        </a>
        {onLogout && (
          <a
            href="#logout"
            className="intro-link"
            title={`Logged in as ${user?.preferred_username || ''}`}
            onClick={(e) => { e.preventDefault(); onLogout(); }}
          >
            Log out
          </a>
        )}
      </div>
    </div>
  );
}
